import { useEffect } from 'react';
import { useGetExpectedDeliveryInformationForProductPageQuery } from 'autogen/swagger/all/hooks';
import useExpectedDeliveryQuickView, {
    type ExpectedDeliveryParams
} from 'components/expecteddelivery/shared/hooks/useExpectedDeliveryQuickView';
import { useProductStore } from 'components/pages/PDP/shared/productStore';

export function useProductPageExpectedDeliveryQuickView() {
    const { productId, isSubscription } = useProductStore();
    const [{ isOpen, params: initialParams }, toggle] = useExpectedDeliveryQuickView();
    const { data: summaryModel } = useGetExpectedDeliveryInformationForProductPageQuery(
        { productId, isSubscription },
        {
            enabled: isOpen && initialParams?.type === 'productPage' && initialParams.productId === productId,
            refetchOnWindowFocus: false
        }
    );

    const params: ExpectedDeliveryParams = {
        type: 'productPage',
        productId,
        isSubscription,
        zipCode: summaryModel?.zipCodeWithSource.zipCode
    };

    useEffect(() => {
        toggle({
            isOpen,
            params
        });
    }, [params.zipCode]);

    return (isOpen: boolean) =>
        toggle({
            isOpen,
            params
        });
}
